import $ from "jquery";
window.$ = window.jQuery = $;

import Polyfills from "./common/Polyfills";
import Globals from "./common/Globals";

import Utils from './common/Utils';
import PJax from "./components/PJax";
import Header from "./components/Header";

import datepicker from './common/datepicker';

class AdminApplication {
    constructor() {
        new Polyfills();
        new Globals();
        this.initialize();
        this.init();
    }

    initialize() {
    }

    static onDOMContentLoaded() {
        Utils.init();
        new PJax();
        Header.RWDAdminMenu();

        datepicker();
    }

    static onLoad() {

    }

    static onResize() {

    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.constructor.onDOMContentLoaded()
        }, false);

        window.onload = () => this.constructor.onLoad();

        window.onresize = () => this.constructor.onResize();
    }
}

const App = new AdminApplication();



// WEBPACK FOOTER //
// ./src/assets/js/Admin.js